import React, { useState, useEffect } from "react";

interface SvgWrapperProps {
  src: string;
  width?: string;
  height?: string;
  className?: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: string;
  urlEndPoint?: string;
}

const SvgWrapper: React.FC<SvgWrapperProps> = ({
  src,
  width = "100%",
  height = "100%",
  className = "",
  fill = "",
  stroke = "currentColor",
  strokeWidth = "1",
  urlEndPoint
}) => {
  const [svgContent, setSvgContent] = useState<string | null>(null);

  useEffect(() => {
    const fetchAndModifySvg = async () => {
      try {
        const response = await fetch(src);
        let text = await response.text();
        // Create a DOM parser to modify the SVG content
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(text, "image/svg+xml");
        const svgElement = svgDoc.querySelector("svg");

        if (svgElement) {
          // Set width and height to 100% to allow CSS control
          height && svgElement.setAttribute("width", height);
          width && svgElement.setAttribute("height", width);

          // Update all fill and stroke attributes to use currentColor
          fill &&
            svgElement.querySelectorAll("[fill]").forEach((el) => {
              el.setAttribute("fill", fill);
            });

          strokeWidth &&
            svgElement.querySelectorAll("[stroke-width]").forEach((el) => {
              el.setAttribute("stroke-width", strokeWidth);
            });

          // Serialize the modified SVG back to a string
          text = new XMLSerializer().serializeToString(svgElement);
        }

        setSvgContent(text);
      } catch (error) {
        console.error("Error fetching or modifying SVG:", error);
      }
    };

    fetchAndModifySvg();
  }, [src, fill, stroke, strokeWidth, width, height]);

  return (
    <div
      className={`inline-block ${className}`}
      style={{ width, height }}
      dangerouslySetInnerHTML={{ __html: svgContent || "" }}
    />
  );
};

export default SvgWrapper;
